import {combineReducers} from 'redux-immutable';

import treeReducer from '../tree/reducer';
import Report from './component';
import paginatorReducer from '../../paginator/reducer';
import mainReducer from './reducer';


export const initialState = {};

export const reducer = combineReducers({
    main: mainReducer,
    regionsTree: treeReducer,
    citiesTree: treeReducer,
    schoolsTree: treeReducer,
    hasExamTreeFilter: treeReducer,
    hasBookTreeFilter: treeReducer,
    examinationStudents: paginatorReducer,
    general: combineReducers({
        paginator: paginatorReducer,
        regionsTreeFilter: treeReducer,
        citiesTreeFilter: treeReducer,
        schoolsTreeFilter: treeReducer,
        gradesTreeFilter: treeReducer,
        hasExamTreeFilter: treeReducer,
        hasBookTreeFilter: treeReducer,
    }),
});

export const component = Report;
